export const FormError = {
    baseStyle: {
        text: {
            color: "states.error",
            fontSize: ".95rem",
            fontWeight: "medium",
            mt: 2
        }
    }
}